import React, { useState, useEffect } from "react";
import ClassNames from "classnames";
import Button from "@material-ui/core/Button";
import AssignmentIcon from "@material-ui/icons/Assignment";

import styles from "./index.module.scss";

import { dayJS } from "../../utils/datetime";
import { apiRequest } from "../../utils/api";
import { useTranslation } from "react-i18next";

export default function CheckPointSummary({ id, ...props }) {
  const { t } = useTranslation();
  const [checkpoints, setCheckpoints] = useState([]);
  const [subjectCheckPoints, setSubjectCheckPoints] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [finalData, setFinalData] = useState([]);

  // get checkpoint details
  useEffect(() => {
    apiRequest
      .get(`/api/getCheckpointDetails?session_id=${id}`)
      .then(response => {
        const data = response.data.data;
        if (data && data.progress_data) {
          setCheckpoints(data.progress_data);
          setFinalData(data.final_data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  //Filter Subjects
  useEffect(() => {
    let newSubjects = [];
    let uniqueIDs = [];
    checkpoints.forEach(cp => {
      if (!uniqueIDs.includes(cp.subject_id)) {
        uniqueIDs.push(cp.subject_id);
        newSubjects.push(cp);
      }
    });
    setSubjects(newSubjects);
  }, [checkpoints]);

  //group by subjects
  useEffect(() => {
    const subjectList = [];
    subjects.map(subject => {
      const subject1 = checkpoints
        .filter(list => subject.subject_id === list.subject_id)
        .sort((a, b) => {
          return new Date(a.checkpoint_date) - new Date(b.checkpoint_date);
        });
      subjectList.push(subject1);
    });
    setSubjectCheckPoints(subjectList);
  }, [subjects]);

  const getFinalDataBySubjectId = (subjectId, key) => {
    return finalData.find(o => {
      return o.subject_id === subjectId;
    });
  };

  return (
    <div className={styles.checkpointScoreGrid}>
      {subjectCheckPoints.length > 0 && (
        <div className={styles.gridHeader}>
          {subjectCheckPoints[0].map((header, index) => (
            <div key={index} className={ClassNames(styles.gridHeaderItem)}>
              <div className={styles.label}>{`${t(
                "updateCheckpoint.checkpoint"
              )} ${index + 1}`}</div>
              <div className={styles.date}>
                {dayJS(header.checkpoint_date).format("DD MMM YYYY")}
              </div>
            </div>
          ))}

          <div className={ClassNames(styles.gridHeaderItem)}>
            <div className={styles.label}>{t("updateCheckpoint.final")}</div>
            <div className={styles.date}>
              {dayJS(finalData[0].review_datetime).format("DD MMM YYYY")}
            </div>
          </div>
        </div>
      )}

      <div className={styles.gridBody}>
        {subjectCheckPoints &&
          subjectCheckPoints.map((subject, index) => (
            <div className={styles.checkpointScoreSubject} key={index}>
              <div className={styles.subjectHeader}>
                <div className={styles.subjectHeaderTitle}>
                  {subject[0].subject}
                </div>
                <div className={styles.subjectHeaderStats}>
                  <div className={styles.subjectHeaderStat}>
                    <span className={styles.label}>
                      {t("updateCheckpoint.previous")}:
                    </span>
                    <span className={styles.value}>
                      {getFinalDataBySubjectId(subject[0].subject_id)
                        .previous_score
                        ? getFinalDataBySubjectId(subject[0].subject_id)
                            .previous_score
                        : ""}
                    </span>
                  </div>
                  <div className={styles.subjectHeaderStat}>
                    <span className={styles.label}>
                      {t("growForm.target")}:
                    </span>
                    <span className={styles.value}>
                      {getFinalDataBySubjectId(subject[0].subject_id)
                        .target_score
                        ? getFinalDataBySubjectId(subject[0].subject_id)
                            .target_score
                        : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.subjectScores}>
                {subject.map((checkPoint, index) => (
                  <div
                    key={index}
                    className={ClassNames(styles.subjectScore, styles.disabled)}
                  >
                    <div className={styles.subjectScoreWrapper}>
                      {checkPoint.checkpoint_progress_value
                        ? checkPoint.checkpoint_progress_value
                        : ""}
                      <div
                        className={ClassNames(
                          styles.subjectScore__btn,
                          styles.disabled
                        )}
                      >
                        <Button
                          variant="contained"
                          disableRipple
                          disableElevation
                          disabled={true}
                        >
                          <AssignmentIcon />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}

                {getFinalDataBySubjectId(subject[0].subject_id) && (
                  <div
                    key={index}
                    className={ClassNames(styles.subjectScore, styles.disabled)}
                  >
                    <div className={styles.subjectScoreWrapper}>
                      {getFinalDataBySubjectId(subject[0].subject_id)
                        .review_progress_score
                        ? getFinalDataBySubjectId(subject[0].subject_id)
                            .review_progress_score
                        : ""}
                      <div
                        className={ClassNames(
                          styles.subjectScore__btn,
                          styles.disabled
                        )}
                      >
                        <Button
                          variant="contained"
                          disableRipple
                          disableElevation
                          disabled={true}
                        >
                          <AssignmentIcon />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
